module.exports = "/_next/static/images/hyperscaleDataCenters-bab1b50d3b435a05219502b12a537f5a.webp";